import React, { createContext, useContext, useState, useCallback } from "react";
import { dataService } from "../services/dataService";
import Modal from "../components/modals/Modal";
import { useOrder } from "./OrderContext";
import { useLocation } from "react-router-dom";

import { IconAlertCircle } from "@tabler/icons-react";

const PrescriptionSaveContext = createContext();

export const PrescriptionSaveProvider = ({ children }) => {
	const [modal, setModal] = useState({ open: false, message: "", type: "danger" });
	const [loading, setLoading] = useState(false);
	const [successMessage, setSuccessMessage] = useState("");
	const { order, updateOrder, replaceOrder, resetOrder } = useOrder();
	const location = useLocation();

	const closeModal = () => setModal({ open: false, message: "", type: "danger" });

	const savePrescription = useCallback(
		async (presctiption) => {
			const calculated_path = location.pathname.startsWith("/") ? location.pathname.slice(1) : location.pathname;
			console.log("Mentés helye:", calculated_path);

			const venyDataWithPath = {
				...presctiption,
				hmeliorder_szam: order.hmeliorder?.hmeliorder_szam,
				save_path_source: calculated_path,
			};

			const aktVenySzam = presctiption.veny?.veny_szam;

			setLoading(true);
			try {
				const response = await dataService.savePrescription(venyDataWithPath);
				const data = response.data;
				if (data.status === "error") {
					setModal({ open: true, message: "<h4>" + data.message + '</h4> <span style="color: grey">Kérem, próbálkozzon újra!</span>' || "Hiba történt a vény mentésekor! Kérem, próbálja újra!", type: "danger" });
					return { success: false, error: data.message };
				}

				const newPrescriptionsData = data.data.venyek;
				let newIndex = 0;
				if (aktVenySzam) {
					const idx = newPrescriptionsData.findIndex((v) => v.veny_szam === aktVenySzam);
					if (idx >= 0) newIndex = idx;
				}
				updateOrder({
					...order,
					venyek: newPrescriptionsData,
					aktivVenyIndex: newIndex,
				});

				setSuccessMessage("Sikeres vény mentés!");
				setTimeout(() => setSuccessMessage(""), 2000);
				setLoading(false);
				return { success: true, data };
			} catch (error) {
				setModal({ open: true, message: "Hiba történt a vény mentésekor! Kérem, próbálja meg újból!", type: "danger" });
				return { success: false, error: error.message };
			} finally {
				setLoading(false);
			}
		},
		[updateOrder, location, order]
	);

	const deletePrescription = useCallback(
		async (venyIndex) => {
			const calculated_path = location.pathname.startsWith("/") ? location.pathname.slice(1) : location.pathname;
			console.log("Törlés helye:", calculated_path);

			const venyToDelete = order.venyek[venyIndex];
			if (!venyToDelete || !venyToDelete.veny_szam) {
				setModal({ open: true, message: "Nem található a törölni kívánt vény!", type: "danger" });
				return { success: false, error: "Vény nem található" };
			}

			const deleteData = {
				hmeliorder_szam: order.hmeliorder?.hmeliorder_szam,
				veny_szam: venyToDelete.veny_szam,
				save_path_source: calculated_path,
			};

			setLoading(true);
			try {
				const response = await dataService.deletePrescription(deleteData);
				const data = response.data;
				if (data.status === "error") {
					setModal({ open: true, message: "<h4>" + data.message + '</h4> <span style="color: grey">Kérem, próbálkozzon újra!</span>' || "Hiba történt a vény törlésekor! Kérem, próbálja újra!", type: "danger" });
					return { success: false, error: data.message };
				}

				const newPrescriptionsData = data.data.venyek;
				updateOrder({
					...order,
					venyek: newPrescriptionsData,
					aktivVenyIndex: Math.max(0, Math.min(order.aktivVenyIndex, newPrescriptionsData.length - 1)),
				});

				setSuccessMessage("Sikeres vény törlés!");
				setTimeout(() => setSuccessMessage(""), 2000);
				setLoading(false);
				return { success: true, data };
			} catch (error) {
				setModal({ open: true, message: "Hiba történt a vény törlésekor! Kérem, próbálja meg újból!", type: "danger" });
				return { success: false, error: error.message };
			} finally {
				setLoading(false);
			}
		},
		[updateOrder, location, order]
	);

	return (
		<PrescriptionSaveContext.Provider value={{ savePrescription, deletePrescription, loading, successMessage }}>
			{children}
			<Modal isOpen={modal.open} onClose={closeModal} onConfirm={closeModal} title={modal.type === "success" ? "Siker" : "Hiba"} type={modal.type} confirmText="OK" showCancel={false} icon={<IconAlertCircle size={48} stroke={2} className="text-danger" />}>
				<div dangerouslySetInnerHTML={{ __html: modal.message }} />
			</Modal>
		</PrescriptionSaveContext.Provider>
	);
};

export const usePrescriptionSave = () => useContext(PrescriptionSaveContext);
